import React from "react";
import ReactDOM from "react-dom";
import { NavLink } from "react-router-dom";
import arrowLeft from "./img/arrow-left.svg";
import arrowRight from "./img/arrow-right.svg";
import { SocialMenu } from "./SocialMenu";
import { Copyright } from "./Copyright";
import Waypoint from "react-waypoint";
export class Project extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInView: true,
      navOffsetTop: ""
    };
  }
  componentDidMount() {
    if (window && window.innerWidth > 767) {
      this.setState({
        navOffsetTop: ReactDOM.findDOMNode(this)
          .getElementsByClassName("project-nav")[0]
          .getBoundingClientRect().top
      });




      window.addEventListener("resize", this.dummyOnLeave);
      window.addEventListener("resize", this.dummyOnEnter);
    }
  }
  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.dummyOnLeave);
      window.removeEventListener("resize", this.dummyOnEnter);
    }
  }
  dummyOnLeave = ({ currentPosition }) => {
    if (window && window.innerWidth > 767) {
      if (currentPosition === Waypoint.above) {
        this.setState({ isInView: false });
      }
    }
  };
  dummyOnEnter = ({ currentPosition }) => {
    if (window && window.innerWidth > 767) {
      if (currentPosition === Waypoint.inside) {
        this.setState({ isInView: true });
      }
    }
  };
  handleNext = () => {
    if (this.currentProject < this.props.filteredProjects.length - 1) {
      this.currentProject += 1;
    }
  };
  handlePrev = () => {
    if (this.currentProject > 0) {
      this.currentProject -= 1;
    }
  };
  render() {
    // this.currentProject = this.props.filteredProjects.findIndex(
    //   p => p.slug === this.props.match.params.slug
    // );

    this.currentProject = this.props.filteredProjects.indexOf(
  this.props.filteredProjects.filter( p => p.slug === this.props.match.params.slug)[0]
);





    let singleImg;
    if (
       this.props.filteredProjects[this.currentProject].acf.gallery.length !== 0
      
    ) {
      let photoGallery = this.props.filteredProjects[this.currentProject].acf
        .gallery;
      let regex = /"htt(.*?)"/gm;


      let match = photoGallery.match(regex);
    




      singleImg = match.map((src, index) => {
        let newSrc = src.slice(1).slice(0, -1);
        return (
          <div key={index} className={`single-project-image-wrap-${index + 1}`}>
            <img src={newSrc} alt={`single-project-${index}`} />
          </div>
        );
      });
    }
    return (
      <div>
        {this.props.isLoading === 4 && (
          <div className="single-project">
            {this.state.isInView && (
              <Waypoint onLeave={this.dummyOnLeave} scrollableAncestor={window}>
                <div
                  style={{
                    width: "10px",
                    position: "absolute",
                    top: "0px",
                    left: "0px",
                    height: "10px",
                    background: "transparent"
                  }}
                />
              </Waypoint>
            )}
            {!this.state.isInView && (
              <Waypoint onEnter={this.dummyOnEnter} scrollableAncestor={window}>
                <div
                  style={{
                    width: "10px",
                    position: "absolute",
                    top: "0px",
                    left: "0px",
                    height: "10px"
                  }}
                />
              </Waypoint>
            )}
            <SocialMenu />
            <Copyright />
            <div className="main-content-wrap">
              <div
                className={this.state.isInView ? "txt-wrap" : "txt-wrap sticky"}
              >
                <h2>
                  {
                    this.props.filteredProjects[this.currentProject].title
                      .rendered
                  }
                </h2>
                <h3>
                  Klient:{" "}
                  <span>
                    {
                      this.props.filteredProjects[this.currentProject].acf
                        .client
                    }
                  </span>
                </h3>
                <h4>
                  /{this.props.filteredProjects[this.currentProject].acf.type}/
                </h4>
                <p dangerouslySetInnerHTML={{ __html:  this.props.filteredProjects[this.currentProject].acf
                      .description }}>
                  
                </p>
              </div>
              <div
                className={
                  this.state.isInView ? "project-nav" : "project-nav sticky"
                }
                style={{
                  top: this.state.isInView ? null : this.state.navOffsetTop
                }}
              >
                {this.currentProject > 0 && (
                  <NavLink
                    className="arrow-btn prev"
                    onClick={this.handlePrev}
                    to={`/${this.props.mainMenu[0].object_slug}/${
                      this.props.filteredProjects[this.currentProject - 1].slug
                    }`}
                  >
                    <span>Poprzedni projekt</span>
                    <img
                      className="arrow left"
                      src={arrowLeft}
                      alt="arrow-left"
                    />
                  </NavLink>
                )}
                {this.currentProject <
                  this.props.filteredProjects.length - 1 && (
                  <NavLink
                    className="arrow-btn next"
                    onClick={this.handleNext}
                    to={`/${this.props.mainMenu[0].object_slug}/${
                      this.props.filteredProjects[this.currentProject + 1].slug
                    }`}
                  >
                    <span>Kolejny projekt</span>
                    <img
                      className="arrow right"
                      src={arrowRight}
                      alt="arrow-right"
                    />
                  </NavLink>
                )}
              </div>
              <div
                className="img-wrap"
                style={{
                  marginBottom: "40px",
                  marginLeft: this.state.isInView ? null : "auto"
                }}
              >
                <img
                  src={
                    this.props.filteredProjects[this.currentProject].acf
                      .posterImage.sizes.large
                  }
                  alt={
                    this.props.filteredProjects[this.currentProject].acf
                      .posterImage.alt
                  }
                />
              </div>
            </div>
            {typeof this.props.filteredProjects[this.currentProject].acf
              .gallery !== "undefined" && (
              <div className="photo-gallery">{singleImg}</div>
            )}
            {typeof this.props.filteredProjects[this.currentProject].acf
              .gallery !== "undefined" &&
              this.props.isMobile && (
                <div className="project-nav">
                  {this.currentProject > 0 && (
                    <NavLink
                      className="arrow-btn prev"
                      onClick={this.handlePrev}
                      to={`/${this.props.mainMenu[0].object_slug}/${
                        this.props.filteredProjects[this.currentProject - 1]
                          .slug
                      }`}
                    >
                      <span>Zobacz poprzedni projekt</span>
                      <img
                        className="arrow left"
                        src={arrowLeft}
                        alt="arrow-left"
                      />
                    </NavLink>
                  )}
                  {this.currentProject <
                    this.props.filteredProjects.length - 1 && (
                    <NavLink
                      className="arrow-btn next"
                      onClick={this.handleNext}
                      to={`/${this.props.mainMenu[0].object_slug}/${
                        this.props.filteredProjects[this.currentProject + 1]
                          .slug
                      }`}
                    >
                      <span>Zobacz kolejny projekt</span>
                      <img
                        className="arrow right"
                        src={arrowRight}
                        alt="arrow-right"
                      />
                    </NavLink>
                  )}
                  <NavLink
                    className="arrow-btn back-to-list"
                    to={`/${this.props.mainMenu[0].object_slug}`}
                  >
                    <span>Powrót do wszystkich projektów</span>
                    <div className="close-project">
                      <div />
                      <div />
                    </div>
                  </NavLink>
                </div>
              )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Project.js